module.exports = __webpack_public_path__ + "static/media/Home-PinkWaveMobile.8e12e7e1.svg";